export enum TargetType {
  TOP = 'top',
  BOTTOM = 'bottom',
}
